import Home from "./images/projects/movieflix/home.png";
import Detail from "./images/projects/movieflix/detail.png";
import Login from "./images/projects/movieflix/login.png";
import Search from "./images/projects/movieflix/search.png";
import MovieFlix from "./images/projects/movieflix/thumbnail.png";

export const projects = [
    {
        id: 1,
        title: "MovieFlix - Movie Streaming",
        description: "Discover a world of entertainment with our movie streaming platform! Enjoy your favorite movies without the hassle of purchasing individual films or paying expensive subscriptions. Our platform makes it easy to explore movies, discover new favorites, and enjoy entertainment in one convenient place.",
        link: "https://github.com/deva3xd/MovieFlix.git",
        images: [
            { id: 1, url: MovieFlix, alt: "Movieflix" },
            { id: 2, url: Home, alt: "Home Page" },
            { id: 2, url: Detail, alt: "Detail Page" },
            { id: 3, url: Login, alt: "Login Page" },
            { id: 4, url: Search, alt: "Search Page" },
        ],
        tech: ["Laravel", "InertiaJs", "Tailwind", "MySQL"],
        overview: "A free movie streaming platform designed to make entertainment accessible to everyone. Users can explore a wide variety of movies and enjoy their favorite content without purchasing individual films or paying subscription fees. The platform focuses on providing a simple, convenient, and enjoyable viewing experience.",
        challenge: "Many movie streaming platforms require users to pay for subscriptions or purchase individual movies before watching. These costs can limit access to entertainment, while complicated interfaces can make discovering and watching movies less convenient. Users need a more accessible and user-friendly way to enjoy movies online.",
        solution: "The platform provides a free and easy-to-use movie streaming experience, allowing users to browse movies, explore different genres, and find content they love without mandatory subscription fees. With a clean interface and straightforward navigation, users can spend less time searching and more time enjoying movies. The service focuses on content that is legally available to stream for free.",
        outcome: "The result is a more accessible and convenient entertainment experience. Users can discover and watch movies without the financial commitment of a subscription, enjoy a smoother browsing experience, and explore a diverse selection of content. The platform aims to make online entertainment simpler, more affordable, and enjoyable for everyone."
    },
    {
        id: 2,
        title: "Beatwave - Music Streaming",
        description: "A lightweight music platform that allows users to upload and stream their own music collection. The app focuses on simplicity and full control, enabling users to listen to their music files online anytime.",
        link: "https://github.com/deva3xd/BeatWave.git",
        images: [
            { id: 1, url: MovieFlix, alt: "Movieflix" },
            { id: 2, url: Home, alt: "Home Page Movieflix" },
            { id: 2, url: Detail, alt: "Detail Page Movieflix" },
            { id: 3, url: Login, alt: "Login Page Movieflix" },
            { id: 4, url: Search, alt: "Search Page Movieflix" },
        ],
        tech: ["NextJs", "Shadcn", "Prisma", "PostgreSQL"],
        overiew: "",
        challenge: "",
        solution: "",
        outcome: "",
    },
    {
        id: 3,
        title: "YourTask - To-Do List",
        description: "A simple and efficient to-do list application that helps users manage daily tasks with ease. All data is stored locally in the browser using local storage, ensuring fast performance and offline accessibility without relying on external services.",
        link: "https://github.com/deva3xd/YourTask.git",
        images: [
            { id: 1, url: MovieFlix, alt: "Movieflix" },
            { id: 2, url: Home, alt: "Home Page Movieflix" },
            { id: 2, url: Detail, alt: "Detail Page Movieflix" },
            { id: 3, url: Login, alt: "Login Page Movieflix" },
            { id: 4, url: Search, alt: "Search Page Movieflix" },
        ],
        tech: ["NextJs", "Tailwind"],
        overiew: "",
        challenge: "",
        solution: "",
        outcome: "",
    },
    {
        id: 4,
        title: "Go-Shopping - E-Commerce",
        description: "A simple e-commerce platform that allows users to buy and sell items easily and quickly. The application provides a seamless shopping experience, enabling users to browse products, make purchases, and manage transactions efficiently.",
        link: "https://github.com/deva3xd/Go-Shopping.git",
        images: [
            { id: 1, url: MovieFlix, alt: "Movieflix" },
            { id: 2, url: Home, alt: "Home Page Movieflix" },
            { id: 2, url: Detail, alt: "Detail Page Movieflix" },
            { id: 3, url: Login, alt: "Login Page Movieflix" },
            { id: 4, url: Search, alt: "Search Page Movieflix" },
        ],
        tech: ["Laravel", "Vite", "Tailwind", "MySQL"],
        overiew: "",
        challenge: "",
        solution: "",
        outcome: "",
    },
]